import { ArrowDownIcon } from '@p2p/assets/svg';
import { ScrollableContainer, Typography } from '@p2p/components';
import classNames from 'classnames';
import { useCallback, useState } from 'react';

import { AmountsItem } from '..';
import styles from './AmountContainer.module.scss';
import { AmountContainerProps } from './AmountContainer.types';

export const AmountContainer = ({
  recommendedAmounts,
  otherAmounts,
  selectedAmount,
  onSelect,
}: AmountContainerProps) => {
  const [isOtherAmountsOpen, setIsOtherAmountsOpen] = useState(false);

  const toggleOtherAmounts = useCallback(() => setIsOtherAmountsOpen((prev) => !prev), []);

  return (
    <div className={styles.amountContainer}>
      <div className={styles.recommendedAmountsContainer}>
        {recommendedAmounts.map((amount) => (
          <AmountsItem
            key={amount}
            amount={amount}
            isSelected={selectedAmount === amount}
            onClick={() => onSelect(amount)}
          />
        ))}
      </div>
      {otherAmounts.length > 0 && (
        <>
          <button className={styles.btnShowMoreAmounts} onClick={toggleOtherAmounts} type="button">
            <Typography variant="text-s-bold" component="span">
              {isOtherAmountsOpen ? 'Свернуть' : 'Показать больше сумм'}
            </Typography>
            <ArrowDownIcon
              className={classNames(styles.btnShowMoreAmountsIcon, {
                [styles.showMoreAmounts]: isOtherAmountsOpen,
              })}
            />
          </button>
          {isOtherAmountsOpen && (
            <ScrollableContainer className={styles.otherAmountsContainer}>
              {otherAmounts.map((amount) => (
                <AmountsItem
                  key={amount}
                  amount={amount}
                  isSelected={selectedAmount === amount}
                  onClick={() => onSelect(amount)}
                />
              ))}
            </ScrollableContainer>
          )}
        </>
      )}
    </div>
  );
};
